(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ClientOpportunityBulkUpdateChangeStage',
	};

	var form_id = 'clientopportunitybulkupdatechangestage-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// stage changes
		$('#' + form_id + 'client_opportunity_stage_id').on('change', function _onChange(e)
		{
			var stage                       = $(this).val();
			var $closed_result              = $('#' + form_id + 'client_opportunity_closed_result_id');
			var $closed_result_note         = $('#' + form_id + 'client_opportunity_closed_result_note');
			var $closed_purchased           = $('#' + form_id + 'client_opportunity_purchased_with');
			var $closed_purchased_elsewhere = $('#' + form_id + 'client_opportunity_closed_result_purchased_elsewhere');

			// reset all other fields
			$('.closed-field').addClass('hidden');
			$('.purchased-fields').addClass('hidden');
			$('.closed-result-fields').addClass('hidden');

			$closed_result.val('');
			$closed_result_note.val('');
			$closed_purchased.val('');
			$closed_purchased_elsewhere.val('');

			Adzuki.Ajax.get('/ClientOpportunities/getStageById/' + stage)
			.then(function _getStageById(stage) {
				if (stage.type === 'closed') {
					$('.closed-field').removeClass('hidden');
					$('.closed-result-fields').removeClass('hidden');
				}
			});
		});

		// closed result changes
		$('#' + form_id + 'client_opportunity_closed_result_id').on('change', function _closedResult(e)
		{
			var result               = $(this).val();
			var $purchased           = $('#' + form_id + 'client_opportunity_purchased_with');
			var $purchased_elsewhere = $('#' + form_id + 'client_opportunity_closed_result_purchased_elsewhere');

			$('.purchased-fields').addClass('hidden');

			$purchased.val('');
			$purchased_elsewhere.val('');

			Adzuki.Ajax.get('/ClientOpportunities/getClosedResultById/' + result)
			.then(function _getClosedResult(result) {
				if (result.id === '5') {
					$('.purchased-fields').removeClass('hidden');
				}
			});
		});

		// purchased with changes
		$('#' + form_id + 'client_opportunity_purchased_with').on('change', function _purchaseWith(e)
		{
			var purchased_with       = $(this).val();
			var $purchased_elsewhere = $('#' + form_id + 'client_opportunity_closed_result_purchased_elsewhere');

			$('.purchased-else-field').addClass('hidden');

			$purchased_elsewhere.val('');

			if (purchased_with === 'other') {
				$('.purchased-else-field').removeClass('hidden');
			}
		});

		$('a.info-link').on('click', function _showInfo(e)
		{
			var $self  = $(this);
			var $modal = $('.modal');
			var body   = $($self.data('modal-id')).html();

			e.preventDefault();

			$modal.find('.modal-title').text($self.data('modal-title'));
			$modal.find('.modal-body').html(body);
			$modal.modal('show');
		});
	};
}(jQuery, window.Adzuki || {}));
